/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Generate_SvrInputs */

const en_ticket_generate_svr = /** @type {(inputs: Ticket_Generate_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate SVR`)
};

const ja_ticket_generate_svr = /** @type {(inputs: Ticket_Generate_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVR生成`)
};

const fr_ticket_generate_svr = /** @type {(inputs: Ticket_Generate_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer SVR`)
};

const de_ticket_generate_svr = /** @type {(inputs: Ticket_Generate_SvrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVR erstellen`)
};

/**
* | output |
* | --- |
* | "Generate SVR" |
*
* @param {Ticket_Generate_SvrInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_generate_svr = /** @type {((inputs?: Ticket_Generate_SvrInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Generate_SvrInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_generate_svr(inputs)
	if (locale === "ja") return ja_ticket_generate_svr(inputs)
	if (locale === "fr") return fr_ticket_generate_svr(inputs)
	return de_ticket_generate_svr(inputs)
});